// Import react
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import Header from "../components/header/header";
import Profile from "../components/profile/profileInBoard";
import BoardDialogue from "../components/dialogue/boardDialogue";
import Avatar from "@mui/material/Avatar";
import CustomButton from "../components/button/button";
import Input from "../components/input/input";
import MessageDialog from "../components/dialogue/messageDialogue";
import Add from "@mui/icons-material/Add";
import Edit from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import Modal from "@material-ui/core/Modal";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "../components/accordion/accordion";
import PersonAddAltRoundedIcon from "@mui/icons-material/PersonAddAltRounded";
import LinkRoundedIcon from "@mui/icons-material/LinkRounded";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { Buffer } from "buffer";
import {
  getAllBoards,
  createBoard,
  updateBoard,
  deleteBoard,
} from "../redux/actions/boardActions";
import Tooltip from "@mui/material/Tooltip";
import Snackbar from "@mui/material/Snackbar";
import { Oval } from "react-loader-spinner";
import Copy from "../components/shareComponent/Copy";
import Mailer from "../components/shareComponent/Mailer";

import { nanoid } from "nanoid";
import Typography from "@mui/material/Typography";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import CloseIcon from "@mui/icons-material/Close";
// Import supabase configuration
import supabase from "../config/supabase";

import { useSelector, useDispatch } from "react-redux";

// Import form
import { useForm } from "react-hook-form";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import logo from '../asstes/clientgaper.png'
/* start of modal styling */
function rand() {
  return Math.round(Math.random() * 20) - 10;
}
function getModalStyle() {
  const top = 50 + rand();
  const left = 50 + rand();
  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}
const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    position: "absolute",
    height: "60%",
    width: "50%",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },

  toggleColor: {
    color: "#4285F4",
  },
}));
/* End of modal styling */

function BoardInfo() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const data = useSelector((state) => state.boards);
  const [profiles, setProfiles] = useState([]);
  const [boardObject, setBoardObject] = useState({});
  const [boardId, setBoardId] = useState("");
  const [boardFromStorage, setStorageBoard] = useState("");
  const [boardName, setBoardName] = useState("");
  const [createBoardFlag, setCreateBoardFlag] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [successfullMessage, setSuccessfullMessage] = useState("");
  const [url, setUrl] = useState("");
  const [clientUrl, setClientUrl] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [expire, setExpire] = useState(10);
  const [getExpire, setGetExpire] = useState([]);
  const [showLoader, setShowLoader] = useState(true);
  const [expiryList, setExpiryList] = useState([
    { value: "10", label: "10 Days" },
    { value: "30", label: "30 Days" },
    { value: "60", label: "60 Days" },
    { value: "100", label: "100 Days" },
  ]);
  const [urlPlaceholder, setUrlPlaceholder] = useState("");
  const [showModal, setshowModal] = useState(false);
  const [showDeleteModal, setshowDeleteModal] = useState(false);
  const [showShareModal, setshowShareModal] = useState(false);
  const [showCopyModal, setshowCopyModal] = useState(false);

  const [emailDiv, setemailDiv] = useState(false);
  const [copyDiv, setcopyDiv] = useState(true);
  // Email already exist
  const [emailFromClient, setEmailFromClient] = useState([]);
  const [defaultExpiry, setDefaultExpiry] = useState();
  // const [screenShotImage,setScreenShotImage] = useState("");
  // commenting to see if my push works tuseef

  {
    /* switch state starts here */
  }
  const [checked, setChecked] = React.useState(false);

  /* Modal state */
  const [open, setOpen] = React.useState(false);
  const [openNew, setOpenNew] = React.useState(false);

  const [modalStyle] = React.useState(getModalStyle);
  /* end of modal state */

  //This hook using for form-validation
  const { handleSubmit } = useForm();
  var emails = [];

  useEffect(async () => {
    document.title = "Board";

    dispatch(getAllBoards());
    var url = new URL(window.location.href);
    var boardId = Buffer.from(
      url.searchParams.get("id") || "",
      "base64"
    ).toString("utf-8");

    setBoardId(boardId);
    getProfiles(boardId);
    setStorageBoard(localStorage.getItem("board") || "");
    setBoardName(localStorage.getItem("board") || "");
    
    // setTimeout(() => {
    //   setShowLoader(false);
    // }, 2500);
  }, []);

  useEffect(()=>{
    var url = new URL(window.location.href);
    var boardId = Buffer.from(
      url.searchParams.get("id") || "",
      "base64"
    ).toString("utf-8");

    checkEmailExist(boardId);
  },[emails])

  const remainingDaysForLink = (emails) => {
    if(emails?.length > 0){
      var newMails = [];
      emails.forEach( (mail) => {
        const expire = mail.expireDate;
        const link_shared_at = new Date(mail.linkSharedAt);

        // Today's date
        const currentDate = new Date();

        var expireDate = new Date();
        expireDate.setDate(link_shared_at.getDate() + expire);

        // To calculate the time difference of two dates
        let Difference_In_Time = expireDate.getTime() - currentDate.getTime();

        // To calculate the no. of days between two dates
        let Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
        Difference_In_Days = Difference_In_Days > 0 ? Difference_In_Days : 0;
        mail = { ... mail, remainingDays: Difference_In_Days}
        newMails.push(mail);
      })
      setEmailFromClient(newMails);
    }
  }

  const handleCheckedChange = (event) => {
    setChecked(event.target.checked);
    updateActiveLink(event.target.checked);
  };

  const handleOpen = () => {
    // setOpen(true);
    setshowShareModal(true);
    // setOpenNew(true);
    getActiveLink();
    checkEmailExist(boardId);
  };

  const handleClose = () => {
    setOpen(false);
    setOpenNew(false);
    setshowShareModal(false);
  };

  const getProfiles = async (boardId) => {
    // Get profiles
    var { data, error } = await supabase
      .from("board_profiles")
      .select("*")
      .match({ board: boardId });

    if (data && data.length > 0) {
      setDefaultExpiry(data[0].expireDate);
    }
    if (data && (data.length > 0 ? (data[0].url ? true : false) : false)) {
      setUrl(data[0].url);
    } else {
      var board_id = Buffer.from(boardId, "utf-8").toString("base64");
      var url = `${window.location.origin}/client?id=${board_id}`;
      setUrl(url);
      insertUrl(url, boardId, data.length <= 0 ? "insert" : "update");
    }

    data.length > 0 && setBoardObject(data[0]);

    var profiles = [];
    if (data && data.length > 0) {
      profiles = data[0].profiles.length > 0
        ? await getProfileDetails(data[0].profiles)
        : [];

      setProfiles(profiles);
    }
    setShowLoader(false);
    setShowMessage(true);
    profiles.length > 0
      ? setSuccessfullMessage("Profiles have been loaded successfully.")
      : setSuccessfullMessage("Please add profles in board");
  };

  const getProfileDetails = async (ids) => {
    var allIds = [];
    ids.forEach( (id) => {
      allIds.push(id.id);
    })
      const { data, error } = await supabase
      .from("all_profiles")
      .select("*")
      .in('id', allIds);
    if(data && data.length > 0) {
      return data
    } else {
      console.log('no profiles');
    }
  };

  const deleteProfile = async (profileId) => {
    setShowLoader(true);

    var client_profiles = boardObject.profiles;
    client_profiles = client_profiles.filter(
      (profile) => profile.id !== profileId
    );

    var { data, error } = await supabase
      .from("board_profiles")
      .update({ profiles: client_profiles })
      .match({ board: boardId });

    var { data, error } = await supabase
    .from("board_clients_invitation")
    .update({ profiles: client_profiles })
    .match({ board: boardId });

    setShowLoader(true);
    getProfiles(boardId);
    setShowMessage(true);
    getScreenShot();
    setSuccessfullMessage("Profile has been deleted successfully");
  };
  {
    /* getting the default expiry date */
  }

  {
    /* Expires list */
  }
  const checkEmailExist = async (boardId) => {
    
    const { data, error } = await supabase
      .from("board_clients_invitation")
      .select("email,expireDate,link_shared_at")
      .eq("board", boardId);

    if (data && data.length) {
      for (var i = 0; i < data.length; i++) {
        emails.push({ email: data[i].email, expireDate: data[i].expireDate, linkSharedAt: data[i].link_shared_at });
      }
      remainingDaysForLink(emails);
    }

  };

  const deleteBoard = async () => {
    setshowDeleteModal(false);
    setShowLoader(true);
    var { data, error } = await supabase
      .from("board_profiles")
      .delete()
      .match({ board: boardId });

    var { data, error } = await supabase
    .from("board_clients_invitation")
    .select("*")
    .match({ board: boardId });

    if(data && data.length){
      let invitations = data;
      for(var i=0 ; i < invitations.length ; i++){
        const { data, error } = await supabase
        .from("notifications")
        .delete()
        .match({ client: invitations[i].id });
      }
    }

    var { data, error } = await supabase
      .from("board_clients_invitation")
      .delete()
      .match({ board: boardId });

    var { error } = await supabase
      .from("board")
      .delete()
      .match({ id: boardId });

    setShowLoader(false);
    navigate("/board");
    
  };

  const deleteClient = async (email) => {
    var { data, error } = await supabase
      .from("board_clients_invitation")
      .delete()
      .match({ email: email, board: boardId });

    if (data && data.length) {
      setShowMessage(true);
      setSuccessfullMessage("Client has been removed successfully.");
      checkEmailExist(boardId);
    } else {
      setShowMessage(true);
      setSuccessfullMessage("Please try again.");
    }
  };

  // function for to get the status of active link
  const getActiveLink = async () => {
    const { data, error } = await supabase
      .from("board_profiles")
      .select("activeLink")
      .eq("board", boardId);

    if (data && data[0].activeLink) {
      setChecked(data[0].activeLink);
    }
  };

  // active link ends here

  {
    /* Update the value of activeLink true or false starts here*/
  }

  const updateActiveLink = async (flag) => {
    const { data, error } = await supabase
      .from("board_profiles")
      .update({ activeLink: flag })
      .match({ board: boardId });
  };

  {
    /* Update the value of activeLink true or false ends here*/
  }
  const insertUrl = async (url, boardId, check) => {
    if (check == "insert") {
      let masked_url = window.location.origin + "/redirect?" + nanoid().substring(0, 6);

      const { data, error } = await supabase
        .from("board_profiles")
        .insert([{ url: url, board: boardId , masked_url:masked_url}]);
    } else {
      const { data, error } = await supabase
        .from("board_profiles")
        .update([{ url }])
        .match({ board: boardId });
    }
  };

  {
    /* update expire on change */
  }
  const updateExpire = async (newExpire, clientEmail) => {
    const { data, error } = await supabase
      .from("board_clients_invitation")
      .update([{ expireDate: newExpire }])
      .match({ email: clientEmail, board: boardId });

    if (data && data.length) {
      setShowMessage(true);
      setSuccessfullMessage("Expire updated successfully.");
    }
  };

  {
    /* update default expire chnage*/
  }
  const updateDefaultExpire = async (defaultExpire) => {
    const { data, error } = await supabase
      .from("board_profiles")
      .update([{ expireDate: defaultExpire }])
      .match({ board: boardId });

    if (data && data.length) {
      setDefaultExpiry(defaultExpire);
      setShowMessage(true);
      setSuccessfullMessage("Expire updated successfully.");
    }
  };

  const insertNotification = async (userEmail, expire, c_url) => {
    const { data, error } = await supabase
      .from("board_clients_invitation")
      .select("*")
      .match({ email: userEmail, board: boardId });

    if (data && data.length) {
      // Set states
      setShowMessage(true);
      setSuccessfullMessage("Board is already shared with this client.");
    } else {
      setShowMessage(true);
      setSuccessfullMessage("Board is shared successfully.");

      var profiles = boardObject.profiles;
      for (var i = 0; i < profiles.length; i++) {
        profiles[i].status = "New";
        profiles[i].message = "";
        profiles[i].meetingTime = "";
        profiles[i].endMeetingTime = "";
      }

      const { data, error } = await supabase
        .from("board_clients_invitation")
        .insert([
          {
            email: userEmail,
            expireDate: expire || 10,
            profiles: profiles,
            board: boardObject.board,
            url_with_token: c_url,
          },
        ]);
    }
  };

  const createUrl = () => {
    var Id = nanoid();
    var board_id = Buffer.from(boardId, "utf-8").toString("base64");

    var newId = board_id.concat("/", Id);
    var str = `${window.location.origin}/client?id=`;
    var newUrl = str.concat(newId);

    return newUrl;
  };

  const editBoard = () => {
    setshowModal(false);
    var selected_board = {
      name: boardName,
      id: boardId,
    };
    dispatch(updateBoard(selected_board));
    setShowMessage(true);
    setSuccessfullMessage("Board has been updated successfully");
    localStorage.setItem("board", boardName);
    setStorageBoard(boardName);
  };

  const getScreenShot =  () => {
    var id = Buffer.from(boardId,
      "utf-8"
    ).toString("base64");

   axios
   .get(`https://shot.screenshotapi.net/screenshot?token=4RRW077-CTRM39S-KYT9CEG-SEXV7FG&url=https://ats-search.netlify.app/sharedProfiles?id=${id}&width=1040&height=750&delay=5000`)
   .then( async(response) => {  
    const Image = response.data.screenshot;
    // setScreenShotImage(Image);
    const { data, error } = await supabase
        .from("board_profiles")
        .update({ profiles_screenshot: Image })
        .match({ board: boardId });
    console.log(Image)


   })
   .catch(function (error) {
     console.log("error in taking screenshot", error);
   });
  };

  async function sendEmailNotification(message) {
    //Setting email template params
    var templateParams = {
      message: message,
      email: "supply@gaper.io",
      to: userEmail,
    };

    //Sending email
    axios
      .post(
        // "http://localhost:5000/sendEmail",
        "https://gaper-email-service.herokuapp.com/sendEmail",
        templateParams,
        {
          headers: { key: "1eb2cy567keyoipaex-assqwe12" },
        }
      )
      .then(function (response) {})
      .catch(function (error) {});
  }

  const sendInvitation = async() => {
    var c_url = createUrl();
    setClientUrl(c_url);

    insertNotification(userEmail, expire, c_url);
    let clientName = userEmail.split('@')[0]

    const { data, error } = await supabase
      .from("board_profiles")
      .select("profiles_screenshot")
      .match({ board: boardId });
      
    // handleClose();
    if(data && data.length > 0){
      sendEmailNotification(`<div>
      <div style="padding-top:25px">
          <img src="https://yourimageshare.com/ib/ImZrKL2FsS.png" alt="GaperLogo here" height="10%" width="20%" />
      </div>
      <div style="padding:15px 50px">
      <p style=" font-size: 17px;  font-family: 'Poppins', sans-serif; margin: 0px;">Hi ${clientName},</p>
      <p style=" font-size: 16px; font-family: 'Poppins', sans-serif; margin: 0px; padding-top: 3px;">We have customised a team of engineer specific for you.</p>
      <div style="margin-top:20px; font-family: 'Poppins', sans-serif; text-align: center;  position:relative;">
          <div style="padding:40px 0px; border:0.9px solid #C8C8C8; border-radius:10px;">
          <a href='${c_url}'>
          <img src="${data[0].profiles_screenshot}" height="40%" width="90%" alt="ScreenShot Image here" /> </a>
          </div>
          <br />
          <div style="text-align: center;">
          <a href='${c_url}'>
            <button style="background-color: #0C60FF; color:#fff; height:42px; width:170px; border-radius: 4px; border: none; font-size: 18px; font-family: 'Inter', sans-serif; text-align: center;">View list</button>
          </a>
          </div>
          <p style="font-family: 'Poppins', sans-serif; font-size: 16px;">This list is valid for 10 days, Hope to see you soon.</p>
      </div>
      </div>
      </div>`);
    }
  };

  const editRate = async(value,profileId) =>{
    let profiles = boardObject.profiles;
    let previousRate = profiles.find(p => p.id == profileId).rate
    profiles.find(p => p.id == profileId).rate = parseInt(value);

    if(previousRate !== parseInt(value)){
      const { data, error } = await supabase
      .from("board_profiles")
      .update({ profiles: profiles })
      .match({ board: boardId });
    }
   
  } 

  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={() => setShowMessage(false)}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  return (
    <div className="w-full min-h-screen h-auto bg-white-2">
      <Header current="home" />
      {
        <Snackbar
          open={showMessage}
          onClose={() => setShowMessage(false)}
          autoHideDuration={2000}
          message={successfullMessage}
          action={action}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        />
      }
      {/* show Loader on condition*/}
      {showLoader && (
        <div className="fixed flex items-center justify-center z-10 w-full h-full top-0 bg-white-1">
          {/* Add backdrop */}
          
          <div className={`relative flex`}>
            <Oval
                color="white"
                secondaryColor="grey"
                height="40"
                width="60"
              />
              <div className="flex items-center">Hold Tight-just getting this page ready.</div>
          </div>
        </div>
      )}

      {/* End of Loader */}

      {/* Message dialogue on board's edit button click start here */}
      <MessageDialog
        title="Update Board"
        onClick={() => {
          setshowModal(false);
        }}
        show={showModal}
      >
        <form onSubmit={handleSubmit(editBoard)}>
          {
            <div className="grid grid-cols-12 gap-3 col-span-12">
              {/* Message */}
              <div className={`col-span-12`}>
                {/* Add message */}
                <Input
                  name="board"
                  value={boardName}
                  placeholder="Enter board name"
                  onInputChange={(e) => {
                    setBoardName(e);
                  }}
                />
              </div>

              {/* Button */}
              <div className="col-span-12 mt-2 flex space-x-2 justify-end">
                <CustomButton
                  type="button"
                  onClick={() => {
                    setshowModal(false);
                  }}
                  value="Cancel"
                  buttonType="cancel"
                />
                 <CustomButton
                  type="submit"
                  value="Update"
                  buttonType="secondary-2"
                />
              </div>
            </div>
          }
        </form>
      </MessageDialog>
      {/* Edit board dialogue button ends here */}

      {/* Share baord modal starts here */}
      {showShareModal ? (
        <>
          <div className={`justify-center w-auto items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none `}>
            <div className={`absolute opacity-20 bg-black-1 w-full h-full`}></div>

            <div className="relative w-auto my-6 mx-auto max-w-3xl w-5/6 sm:w-3/5 md:w-1/2 lg:w-2/5">
              {/*content*/}
              <div className="border-0 rounded-lg relative flex flex-col w-full   bg-white-1 outline-none focus:outline-none">
                {/*header*/}
                <div
                  onClick={() => {
                    setemailDiv(false);
                    setcopyDiv(true);
                  }}
                  className="flex items-start justify-between p-8 rounded-t -mt-4"
                >
                  <div className="-ml-3 -mb-8 ">
                    <div className="bg-blue-1 rounded-full p-1 mx-1 inline-block">
                      <PersonAddAltRoundedIcon className="text-white-1" />
                    </div>
                    <h3 className="text-lg font-semibold my-1 inline-block ">
                      Share board with people
                    </h3>
                  </div>
                  <button
                    className="p-1 -px-6 ml-auto bg-transparent border-0 text-blue-1  float-right text-xl leading-none font-semibold outline-none focus:outline-none"
                    onClick={() => setshowShareModal(false)}
                  >
                    <span className="bg-transparent text-black opacity-100 h-6 w-6 text-2xl block outline-none focus:outline-none">
                      ×
                    </span>
                  </button>
                </div>

                {emailDiv ? (
                  <div className="select-none px-8 -mt-2">
                    {emailFromClient.length ? (
                      <div>
                        <div className="font-semibold">Shared with: </div>
                        {emailFromClient.map((client, index) => {
                          return (
                            <span key={index} className="break-words">
                              {client.email && client.email.split("@")[0]},
                            </span>
                          );
                        })}
                      </div>
                    ) : (
                      <div>No one has been added yet</div>
                    )}
                  </div>
                ) : null}

                {/*body*/}
                <div
                  className={`relative p-6 flex-auto ${
                    emailDiv ? "hidden" : ""
                  }`}
                >
                  <div className="-mt-8 ml-2">
                    <Mailer
                      userEmail={userEmail}
                      getChange={(data) => {
                        setUserEmail(data);
                      }}
                      getExpire={(e) => setExpire(e)}
                      emailFromClient={emailFromClient}
                      setshowShareModal={setshowShareModal}
                      sendInvitation={sendInvitation}
                      deleteClient={deleteClient}
                      updateExpire={updateExpire}
                      setExpire={setExpire}
                    />
                  </div>
                </div>
                {/*Copy*/}
                <div className="-mt-6">
                  <div
                    onClick={() => {
                      setemailDiv(true);
                      setcopyDiv(false);
                    }}
                    className="flex items-start justify-between p-8 rounded-t"
                  >
                    <div className="-ml-3 ">
                      <div className="bg-blue-1 rounded-full p-1 mx-1 inline-block">
                        <LinkRoundedIcon className="text-white-1" />
                      </div>
                      <h3 className="text-lg font-semibold my-1 inline-block ">
                        Copy Link
                      </h3>
                    </div>
                    <button
                      disabled
                      className="p-1 ml-auto bg-transparent border-0 text-blue-1  float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                      onClick={() => setshowShareModal(false)}
                    >
                      <span className="bg-transparent text-black opacity-0 h-6 w-6 text-2xl block outline-none focus:outline-none">
                        ×
                      </span>
                    </button>
                  </div>
                  {copyDiv ? (
                    <div className="select-none text-sm px-8 mb-4 -mt-4 ...">
                      Anyone on the internet with this link can view
                    </div>
                  ) : null}
                  {/*Copy body*/}
                  <div
                    className={`relative flex-auto ${copyDiv ? "hidden" : ""}`}
                  >
                    <div className="-mt-6">
                      <Copy
                        url={url}
                        urlPlaceholder={urlPlaceholder}
                        checked={checked}
                        handleCheckedChange={handleCheckedChange}
                        handleClose={handleClose}
                        updateDefaultExpire={updateDefaultExpire}
                        defaultExpiry={defaultExpiry}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}

      {/* Message dialogue on board's delete button click start here */}
      <MessageDialog
        title="Delete Board"
        onClick={() => {
          setshowDeleteModal(false);
        }}
        show={showDeleteModal}
      >
        <form className="" onSubmit={handleSubmit(deleteBoard)}>
          {
            <div className="grid grid-cols-12 gap-3 col-span-12">
              {/* Show message */}
              <div className="col-span-12 ">
                Are you sure you want to delete this board?
              </div>

              {/* Button */}
              <div className="col-span-12 mt-2 flex space-x-2 justify-end">
                <CustomButton
                  type="submit"
                  value="Delete"
                  buttonType="secondary-2"
                />
                <CustomButton
                  type="button"
                  onClick={() => {
                    setshowDeleteModal(false);
                  }}
                  value="Cancel"
                  buttonType="cancel"
                />
              </div>
            </div>
          }
        </form>
      </MessageDialog>
      {/* Delete board dialogue button ends here */}

      <div className="px-10">
        {/* Board name */}
        <div className="flex mt-20 justify-center text-4xl font-bold">
          {boardFromStorage}
        </div>

        <div className="mt-10 flex justify-center space-x-2">
          <div className="bg-grey-4 rounded-full hover:bg-grey-2 p-2 w-10 h-10 flex justify-center">
            {/* Edit */}
            <Tooltip title="Edit board">
            <IconButton
              onClick={() => setshowModal(true)}
              size="small"
              sx={{ color: "black" }}
            >
                <Edit fontSize="small" />
              </IconButton>
            </Tooltip>
          </div>
         
          {/* Delete */}
          <div className="bg-grey-4 rounded-full hover:bg-grey-2 p-2 w-10 h-10 flex justify-center">
            <Tooltip title="Delete board">
              <IconButton
                onClick={() => setshowDeleteModal(true)}
                size="small"
                sx={{ color: "black"}}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </div>

          {/* Share */}
          <div className="bg-grey-4 rounded-full hover:bg-grey-2 p-2 w-10 h-10 flex justify-center">
            <Tooltip title="Share board">
              <IconButton
                onClick={handleOpen}
                size="small"
                sx={{ color: "Black"}}
                aria-label="add"
              >
                <Add fontSize="small" />
              </IconButton>
            </Tooltip>
          </div>
        </div>
        <div>
          <Stack spacing={2}>
            <Breadcrumbs
              separator={<NavigateNextIcon fontSize="small" />}
              aria-label="breadcrumb"
            >
              <Typography variant="h6">
                <span
                  onClick={() => navigate("/")}
                  className="hover:underline cursor-pointer hover:text-blue-1"
                >
                  Home
                </span>
              </Typography>
              <Typography variant="h6">
                <span
                  onClick={() => navigate("/board")}
                  className="hover:underline cursor-pointer hover:text-blue-1"
                >
                  Board
                </span>
              </Typography>
              <Typography variant="h6">
                <span>{boardName}</span>
              </Typography>
            </Breadcrumbs>
          </Stack>
        </div>
        {(profiles && profiles.length > 0) && (
          <div>
            <div className="font-bold text-xl py-3">Profiles:</div>
            <div className="col-span-12 grid grid-cols-12 gap-4">
              {profiles.map((profile, index) => (
                <div key={index} className="col-span-3">
                  <Profile profile={profile} deleteProfile={deleteProfile} boardProfiles={boardObject?.profiles} editClientRate={editRate}/>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default BoardInfo;
